import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_1397_25179)">
      <path
        d="M9.9974 18.3334C14.5998 18.3334 18.3307 14.6025 18.3307 10.0001C18.3307 5.39771 14.5998 1.66675 9.9974 1.66675C5.39502 1.66675 1.66406 5.39771 1.66406 10.0001C1.66406 14.6025 5.39502 18.3334 9.9974 18.3334Z"
        fill="#D90D0D"
        stroke="#D90D0D"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7.5L12.5 12.5"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1397_25179">
        <rect width={20} height={20} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SVGComponent;
